import { render } from "./index.vue?vue&type=template&id=e07107c4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=e07107c4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e07107c4"

export default script